import React from 'react';

export const CartLineIcon = ({
  ref,
  ...props
}: React.SVGProps<SVGSVGElement> & {
  ref?: React.RefObject<SVGSVGElement>;
}) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={20}
    height={20}
    fill='none'
    viewBox='0 0 20 20'
    {...props}
    ref={ref}
  >
    <g clipPath='url(#a)'>
      <path
        fill='currentColor'
        d='M15.833 16.666H4.167v.834a.833.833 0 0 1-.834.833H2.5a.833.833 0 0 1-.833-.833V9.166l2.066-4.823a1.667 1.667 0 0 1 1.534-1.01h9.466a1.667 1.667 0 0 1 1.532 1.01l2.068 4.823V17.5a.833.833 0 0 1-.833.833h-.833a.833.833 0 0 1-.834-.833v-.834Zm.834-5.833H3.333V15h13.334v-4.167ZM3.48 9.166h13.04L14.734 5H5.267L3.48 9.166Zm1.937 5a1.25 1.25 0 1 1 0-2.5 1.25 1.25 0 0 1 0 2.5Zm9.166 0a1.25 1.25 0 1 1 0-2.5 1.25 1.25 0 0 1 0 2.5Z'
      />
    </g>
    <defs>
      <clipPath id='a'>
        <path fill='#fff' d='M0 0h20v20H0z' />
      </clipPath>
    </defs>
  </svg>
);
export const TruckLineIcon = ({
  ref,
  ...props
}: React.SVGProps<SVGSVGElement> & {
  ref?: React.RefObject<SVGSVGElement>;
}) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={20}
    height={20}
    fill='none'
    viewBox='0 0 20 20'
    {...props}
    ref={ref}
  >
    <g clipPath='url(#a)'>
      <path
        fill='#5D6E82'
        d='M7.47 15a2.916 2.916 0 0 1-5.774 0H.833V5a.833.833 0 0 1 .834-.833h11.666a.833.833 0 0 1 .834.833v1.667h2.5l2.5 3.38V15H17.47a2.916 2.916 0 0 1-5.775 0H7.47Zm5.03-9.166h-10v6.708a2.917 2.917 0 0 1 4.72.792h4.727c.14-.294.328-.562.553-.792V5.834Zm1.667 5H17.5v-.238l-1.673-2.262h-1.66v2.5Zm.416 5a1.25 1.25 0 1 0 0-2.501 1.25 1.25 0 0 0 0 2.5Zm-8.75-1.25a1.25 1.25 0 1 0-2.5 0 1.25 1.25 0 0 0 2.5 0Z'
      />
    </g>
    <defs>
      <clipPath id='a'>
        <path fill='#fff' d='M0 0h20v20H0z' />
      </clipPath>
    </defs>
  </svg>
);
export const MotorbikeIcon = ({
  ref,
  ...props
}: React.SVGProps<SVGSVGElement> & {
  ref?: React.RefObject<SVGSVGElement>;
}) => (
  <svg
    width='20'
    height='20'
    viewBox='0 0 20 20'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
    ref={ref}
  >
    <g clipPath='url(#clip0_2540_28357)'>
      <path
        d='M6.97076 8.33333L9.33326 6.66667H14.1666V8.33333H9.87993L7.49993 10H1.66659V8.33333H6.97076ZM7.73409 12.55L10.1716 11.6625L10.7416 13.2292L8.30409 14.1158C8.41884 15.0306 8.19258 15.9556 7.66854 16.7141C7.1445 17.4726 6.3594 18.0115 5.46321 18.2279C4.56701 18.4442 3.62252 18.3228 2.81015 17.8869C1.99778 17.451 1.37446 16.7311 1.05925 15.8647C0.744032 14.9983 0.759017 14.0462 1.10134 13.1902C1.44366 12.3341 2.08933 11.6342 2.91502 11.2241C3.74071 10.8139 4.68854 10.7223 5.57749 10.9668C6.46643 11.2112 7.23418 11.7745 7.73409 12.5492V12.55ZM4.58326 16.6667C5.1358 16.6667 5.6657 16.4472 6.0564 16.0565C6.4471 15.6658 6.66659 15.1359 6.66659 14.5833C6.66659 14.0308 6.4471 13.5009 6.0564 13.1102C5.6657 12.7195 5.1358 12.5 4.58326 12.5C4.03073 12.5 3.50082 12.7195 3.11012 13.1102C2.71942 13.5009 2.49993 14.0308 2.49993 14.5833C2.49993 15.1359 2.71942 15.6658 3.11012 16.0565C3.50082 16.4472 4.03073 16.6667 4.58326 16.6667ZM15.4166 18.3333C14.9241 18.3333 14.4365 18.2363 13.9815 18.0479C13.5266 17.8594 13.1132 17.5832 12.7649 17.235C12.4167 16.8868 12.1405 16.4734 11.952 16.0184C11.7636 15.5634 11.6666 15.0758 11.6666 14.5833C11.6666 14.0909 11.7636 13.6032 11.952 13.1483C12.1405 12.6933 12.4167 12.2799 12.7649 11.9317C13.1132 11.5835 13.5266 11.3072 13.9815 11.1188C14.4365 10.9303 14.9241 10.8333 15.4166 10.8333C16.4112 10.8333 17.365 11.2284 18.0682 11.9317C18.7715 12.6349 19.1666 13.5888 19.1666 14.5833C19.1666 15.5779 18.7715 16.5317 18.0682 17.235C17.365 17.9382 16.4112 18.3333 15.4166 18.3333ZM15.4166 16.6667C15.9691 16.6667 16.499 16.4472 16.8897 16.0565C17.2804 15.6658 17.4999 15.1359 17.4999 14.5833C17.4999 14.0308 17.2804 13.5009 16.8897 13.1102C16.499 12.7195 15.9691 12.5 15.4166 12.5C14.8641 12.5 14.3342 12.7195 13.9435 13.1102C13.5528 13.5009 13.3333 14.0308 13.3333 14.5833C13.3333 15.1359 13.5528 15.6658 13.9435 16.0565C14.3342 16.4472 14.8641 16.6667 15.4166 16.6667ZM3.33326 9.16667H8.33326L10.4999 7.7225L10.7333 6.85083L12.3433 7.2825L10.7416 13.225L9.22326 12.485L9.32159 12.1183L7.49993 13.3333L6.66659 11.6667H3.33326V9.16667ZM13.4099 5H16.6666V7.5H14.3199L15.9199 11.8967L14.3533 12.4667L12.5466 7.5H12.4999V7.37333L11.3333 4.16667H9.16659V2.5H12.4999L13.4099 5Z'
        fill='#5D6E82'
      />
    </g>
    <defs>
      <clipPath id='clip0_2540_28357'>
        <rect width='20' height='20' fill='white' />
      </clipPath>
    </defs>
  </svg>
);

export const MoneyEuroBoxIcon = ({
  ref,
  ...props
}: React.SVGProps<SVGSVGElement> & {
  ref?: React.RefObject<SVGSVGElement>;
}) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={20}
    height={20}
    fill='none'
    viewBox='0 0 20 20'
    {...props}
    ref={ref}
  >
    <g clipPath='url(#a)'>
      <path
        fill='currentColor'
        d='M2.25 2.75h13.5a.75.75 0 0 1 .75.75v12a.75.75 0 0 1-.75.75H2.25a.75.75 0 0 1-.75-.75v-12a.75.75 0 0 1 .75-.75ZM3 4.25v10.5h12V4.25H3Zm4.537 4.5h3.713v1.5H7.537a1.875 1.875 0 0 0 3.048 1.057l1.275.85a3.375 3.375 0 0 1-5.839-1.907H5.25v-1.5h.77a3.375 3.375 0 0 1 5.841-1.907l-1.276.85A1.875 1.875 0 0 0 7.537 8.75Z'
      />
    </g>
    <defs>
      <clipPath id='a'>
        <path fill='currentColor' d='M0 .5h18v18H0z' />
      </clipPath>
    </defs>
  </svg>
);
export const SearchIcon = ({
  ref,
  ...props
}: React.SVGProps<SVGSVGElement> & {
  ref?: React.RefObject<SVGSVGElement>;
}) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='1em'
    height='1em'
    fill='none'
    stroke='currentColor'
    strokeLinecap='round'
    strokeLinejoin='round'
    strokeWidth={2}
    viewBox='0 0 24 24'
    {...props}
    ref={ref}
  >
    <circle cx={11} cy={11} r={8} />
    <path d='m21 21-4.35-4.35' />
  </svg>
);
export const TrashIcon = ({
  ref,
  ...props
}: React.SVGProps<SVGSVGElement> & {
  ref?: React.RefObject<SVGSVGElement>;
}) => (
  <svg
    width='1em'
    height='1em'
    viewBox='0 0 20 20'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
    ref={ref}
  >
    <g clipPath='url(#clip0_2433_2546)'>
      <path
        d='M14 5.2H18V6.8H16.4V17.2C16.4 17.4122 16.3157 17.6157 16.1657 17.7657C16.0157 17.9157 15.8122 18 15.6 18H4.4C4.18783 18 3.98434 17.9157 3.83431 17.7657C3.68429 17.6157 3.6 17.4122 3.6 17.2V6.8H2V5.2H6V2.8C6 2.58783 6.08429 2.38434 6.23431 2.23431C6.38434 2.08429 6.58783 2 6.8 2H13.2C13.4122 2 13.6157 2.08429 13.7657 2.23431C13.9157 2.38434 14 2.58783 14 2.8V5.2ZM14.8 6.8H5.2V16.4H14.8V6.8ZM7.6 9.2H9.2V14H7.6V9.2ZM10.8 9.2H12.4V14H10.8V9.2ZM7.6 3.6V5.2H12.4V3.6H7.6Z'
        fill='currentColor'
      />
    </g>
    <defs>
      <clipPath id='clip0_2433_2546'>
        <rect
          width='19.2'
          height='19.2'
          fill='white'
          transform='translate(0.399902 0.400391)'
        />
      </clipPath>
    </defs>
  </svg>
);
export const ArrowsAltIcon = ({
  ref,
  ...props
}: React.SVGProps<SVGSVGElement> & {
  ref?: React.RefObject<SVGSVGElement>;
}) => (
  <svg
    width='1em'
    height='1em'
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
    ref={ref}
  >
    <path
      d='M18 11V8L22 12L18 16V13H13V18H16L12 22L8 18H11V13H6V16L2 12L6 8V11H11V6H8L12 2L16 6H13V11H18Z'
      fill='currentColor'
    />
  </svg>
);
export const EditAltIcon = ({
  ref,
  ...props
}: React.SVGProps<SVGSVGElement> & {
  ref?: React.RefObject<SVGSVGElement>;
}) => (
  <svg
    stroke='currentColor'
    fill='currentColor'
    strokeWidth='0'
    viewBox='0 0 576 512'
    height='1em'
    width='1em'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
    ref={ref}
  >
    <path d='M402.6 83.2l90.2 90.2c3.8 3.8 3.8 10 0 13.8L274.4 405.6l-92.8 10.3c-12.4 1.4-22.9-9.1-21.5-21.5l10.3-92.8L388.8 83.2c3.8-3.8 10-3.8 13.8 0zm162-22.9l-48.8-48.8c-15.2-15.2-39.9-15.2-55.2 0l-35.4 35.4c-3.8 3.8-3.8 10 0 13.8l90.2 90.2c3.8 3.8 10 3.8 13.8 0l35.4-35.4c15.2-15.3 15.2-40 0-55.2zM384 346.2V448H64V128h229.8c3.2 0 6.2-1.3 8.5-3.5l40-40c7.6-7.6 2.2-20.5-8.5-20.5H48C21.5 64 0 85.5 0 112v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V306.2c0-10.7-12.9-16-20.5-8.5l-40 40c-2.2 2.3-3.5 5.3-3.5 8.5z'></path>
  </svg>
);
export const InfoCircleIcon = ({
  ref,
  ...props
}: React.SVGProps<SVGSVGElement> & {
  ref?: React.RefObject<SVGSVGElement>;
}) => (
  <svg
    stroke='currentColor'
    fill='currentColor'
    strokeWidth='0'
    viewBox='0 0 512 512'
    height='1em'
    width='1em'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
    ref={ref}
  >
    <path d='M256 8C119.043 8 8 119.083 8 256c0 136.997 111.043 248 248 248s248-111.003 248-248C504 119.083 392.957 8 256 8zm0 110c23.196 0 42 18.804 42 42s-18.804 42-42 42-42-18.804-42-42 18.804-42 42-42zm56 254c0 6.627-5.373 12-12 12h-88c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h12v-64h-12c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h64c6.627 0 12 5.373 12 12v100h12c6.627 0 12 5.373 12 12v24z'></path>
  </svg>
);
export const PlusIcon = ({
  ref,
  ...props
}: React.SVGProps<SVGSVGElement> & {
  ref?: React.RefObject<SVGSVGElement>;
}) => (
  <svg
    width='16'
    height='17'
    viewBox='0 0 16 17'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
    ref={ref}
  >
    <g clipPath='url(#clip0_9289_43048)'>
      <path
        d='M7.33301 7.83301V3.83301H8.66634V7.83301H12.6663V9.16634H8.66634V13.1663H7.33301V9.16634H3.33301V7.83301H7.33301Z'
        fill='currentColor'
      />
    </g>
    <defs>
      <clipPath id='clip0_9289_43048'>
        <rect
          width='16'
          height='16'
          fill='white'
          transform='translate(0 0.5)'
        />
      </clipPath>
    </defs>
  </svg>
);
export const MinusIcon = ({
  ref,
  ...props
}: React.SVGProps<SVGSVGElement> & {
  ref?: React.RefObject<SVGSVGElement>;
}) => (
  <svg
    strokeWidth='0'
    viewBox='0 0 1024 1024'
    height='1em'
    width='1em'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
    ref={ref}
  >
    <path
      fill='currentColor'
      d='M872 474H152c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h720c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8z'
    ></path>
  </svg>
);
export const PrintIcon = ({
  ref,
  ...props
}: React.SVGProps<SVGSVGElement> & {
  ref?: React.RefObject<SVGSVGElement>;
}) => (
  <svg
    stroke='currentColor'
    fill='currentColor'
    strokeWidth='0'
    viewBox='0 0 24 24'
    height='1em'
    width='1em'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
    ref={ref}
  >
    <path fill='none' d='M0 0h24v24H0z'></path>
    <path d='M19 8H5c-1.66 0-3 1.34-3 3v6h4v4h12v-4h4v-6c0-1.66-1.34-3-3-3zm-3 11H8v-5h8v5zm3-7c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm-1-9H6v4h12V3z'></path>
  </svg>
);
export const UndoIcon = ({
  ref,
  ...props
}: React.SVGProps<SVGSVGElement> & {
  ref?: React.RefObject<SVGSVGElement>;
}) => (
  <svg
    stroke='currentColor'
    fill='currentColor'
    strokeWidth='0'
    viewBox='0 0 24 24'
    height='1em'
    width='1em'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
    ref={ref}
  >
    <path fill='none' d='M0 0h24v24H0z'></path>
    <path d='M12.5 8c-2.65 0-5.05.99-6.9 2.6L2 7v9h9l-3.62-3.62c1.39-1.16 3.16-1.88 5.12-1.88 3.54 0 6.55 2.31 7.6 5.5l2.37-.78C21.08 11.03 17.15 8 12.5 8z'></path>
  </svg>
);
export const SunIcon = ({
  ref,
  ...props
}: React.SVGProps<SVGSVGElement> & {
  ref?: React.RefObject<SVGSVGElement>;
}) => (
  <svg
    width='24'
    height='24'
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
    ref={ref}
  >
    <g clipPath='url(#clip0_2540_5168)'>
      <path
        d='M12 18C10.4087 18 8.88258 17.3679 7.75736 16.2426C6.63214 15.1174 6 13.5913 6 12C6 10.4087 6.63214 8.88258 7.75736 7.75736C8.88258 6.63214 10.4087 6 12 6C13.5913 6 15.1174 6.63214 16.2426 7.75736C17.3679 8.88258 18 10.4087 18 12C18 13.5913 17.3679 15.1174 16.2426 16.2426C15.1174 17.3679 13.5913 18 12 18ZM12 16C13.0609 16 14.0783 15.5786 14.8284 14.8284C15.5786 14.0783 16 13.0609 16 12C16 10.9391 15.5786 9.92172 14.8284 9.17157C14.0783 8.42143 13.0609 8 12 8C10.9391 8 9.92172 8.42143 9.17157 9.17157C8.42143 9.92172 8 10.9391 8 12C8 13.0609 8.42143 14.0783 9.17157 14.8284C9.92172 15.5786 10.9391 16 12 16ZM11 1H13V4H11V1ZM11 20H13V23H11V20ZM3.515 4.929L4.929 3.515L7.05 5.636L5.636 7.05L3.515 4.929ZM16.95 18.364L18.364 16.95L20.485 19.071L19.071 20.485L16.95 18.364ZM19.071 3.514L20.485 4.929L18.364 7.05L16.95 5.636L19.071 3.515V3.514ZM5.636 16.95L7.05 18.364L4.929 20.485L3.515 19.071L5.636 16.95ZM23 11V13H20V11H23ZM4 11V13H1V11H4Z'
        fill='#F6B816'
      />
    </g>
    <defs>
      <clipPath id='clip0_2540_5168'>
        <rect width='24' height='24' fill='white' />
      </clipPath>
    </defs>
  </svg>
);
export const FlakeIcon = ({
  ref,
  ...props
}: React.SVGProps<SVGSVGElement> & {
  ref?: React.RefObject<SVGSVGElement>;
}) => (
  <svg
    width='24'
    height='24'
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
    ref={ref}
  >
    <path
      d='M11.0429 6.80431L8.45757 4.29897L9.79799 3L12.0001 5.13402L14.2023 3L15.5427 4.29897L12.9578 6.80393V10.3254L16.0558 8.44746L16.883 5.04082L18.7021 5.41195L18.0319 8.38103L21 9.03051L20.617 10.7934L17.0326 10.0442L13.8048 12.0008L17.0297 13.9556L20.617 13.2058L21 14.9687L18.0319 15.6181L18.7021 18.5872L16.883 18.9583L16.0565 15.5545L12.9578 13.6761V17.1961L15.5427 19.701L14.2023 21L12.0001 18.866L9.79799 21L8.45757 19.701L11.0429 17.1957V13.675L7.94369 15.5537L7.11702 18.9583L5.29787 18.5872L5.96809 15.6181L3 14.9687L3.38298 13.2058L6.96949 13.9554L10.1939 12.0008L6.96634 10.0444L3.38298 10.7934L3 9.03051L5.96809 8.38103L5.29787 5.41195L7.11702 5.04082L7.94442 8.4485L11.0429 10.3266V6.80431Z'
      fill='#2ABBFC'
    />
  </svg>
);
export const FourSeasonIcon = ({
  ref,
  ...props
}: React.SVGProps<SVGSVGElement> & {
  ref?: React.RefObject<SVGSVGElement>;
}) => (
  <svg
    width='24'
    height='24'
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
    ref={ref}
  >
    <g clipPath='url(#clip0_3543_15743)'>
      <path
        d='M6.85718 17.1426L4.92871 19.0711L4.28588 18.4283L6.21436 16.4998L6.85718 17.1426Z'
        fill='#F6B816'
      />
      <path
        d='M19.0708 4.92895L17.1424 6.85742L16.4995 6.2146L18.428 4.28613L19.0708 4.92895Z'
        fill='#F6B816'
      />
      <path
        d='M15.8567 8.14307L14.5711 9.42872C13.8891 8.74677 12.9642 8.36366 11.9998 8.36366C11.0354 8.36366 10.1104 8.74677 9.42848 9.42872C8.74653 10.1107 8.36341 11.0356 8.36341 12C8.36341 12.9644 8.74653 13.8894 9.42848 14.5713L8.14283 15.857C7.1199 14.834 6.54523 13.4467 6.54523 12C6.54523 10.5534 7.11991 9.166 8.14283 8.14307C9.16576 7.12015 10.5531 6.54547 11.9998 6.54547C13.4464 6.54547 14.8338 7.12015 15.8567 8.14307Z'
        fill='#F6B816'
      />
      <path
        d='M12.9087 2.00024H11.0908V4.72711L12.9087 4.72711V2.00024Z'
        fill='#F6B816'
      />
      <path
        d='M4.72686 12.909L4.72686 11.0911H2L2 12.909L4.72686 12.909Z'
        fill='#F6B816'
      />
      <path
        d='M6.21436 7.50025L7.50001 6.2146L5.57153 4.28613L4.28588 5.57178L6.21436 7.50025Z'
        fill='#F6B816'
      />
      <path
        d='M9.09838 17.7298L17.7296 9.09862L20.455 9.14158L20.4811 10.8005L17.2819 10.7503L15.0685 12.9637L18.1962 13.7306L20.8573 12.1093L21.7674 13.4859L19.48 14.9309L20.9373 17.2046L19.5885 18.072L17.8065 15.3481L14.5479 14.5491L15.3462 17.8047L18.0723 19.5882L17.2049 20.937L14.9311 19.4797L13.4862 21.7671L12.1095 20.857L13.7295 18.198L12.9625 15.0698L10.7501 17.2822L10.8003 20.4813L9.14134 20.4553L9.09838 17.7298Z'
        fill='#2ABBFC'
      />
    </g>
    <defs>
      <clipPath id='clip0_3543_15743'>
        <rect width='24' height='24' fill='white' />
      </clipPath>
    </defs>
  </svg>
);
export const MountainFlakeIcon = ({
  ref,
  ...props
}: React.SVGProps<SVGSVGElement> & {
  ref?: React.RefObject<SVGSVGElement>;
}) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='176'
    height='166'
    viewBox='0 0 176 166'
    ref={ref}
    {...props}
  >
    <image
      id='Calque_1'
      width='176'
      height='166'
      href='data:img/png;base64,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'
    />
  </svg>
);
export const TagIcon = ({
  ref,
  ...props
}: React.SVGProps<SVGSVGElement> & {
  ref?: React.RefObject<SVGSVGElement>;
}) => (
  <svg
    stroke='currentColor'
    fill='currentColor'
    strokeWidth='0'
    viewBox='0 0 512 512'
    height='1em'
    width='1em'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
    ref={ref}
  >
    <path d='M0 252.118V48C0 21.49 21.49 0 48 0h204.118a48 48 0 0 1 33.941 14.059l211.882 211.882c18.745 18.745 18.745 49.137 0 67.882L293.823 497.941c-18.745 18.745-49.137 18.745-67.882 0L14.059 286.059A48 48 0 0 1 0 252.118zM112 64c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48z'></path>
  </svg>
);

export const StarIcon = ({
  ref,
  ...props
}: React.SVGProps<SVGSVGElement> & {
  ref?: React.RefObject<SVGSVGElement>;
}) => (
  <svg
    width='24'
    height='24'
    viewBox='0 0 24 24'
    stroke='currentColor'
    fill='currentColor'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
    ref={ref}
  >
    <g clipPath='url(#clip0_2540_34247)'>
      <path d='M11.9989 18.26L4.94594 22.208L6.52094 14.28L0.585938 8.792L8.61294 7.84L11.9989 0.5L15.3849 7.84L23.4119 8.792L17.4769 14.28L19.0519 22.208L11.9989 18.26Z' />
    </g>
    <defs>
      <clipPath id='clip0_2540_34247'>
        <rect width='24' height='24' fill='white' />
      </clipPath>
    </defs>
  </svg>
);
export const AlertIcon = ({
  ref,
  ...props
}: React.SVGProps<SVGSVGElement> & {
  ref?: React.RefObject<SVGSVGElement>;
}) => (
  <svg
    width='24'
    height='24'
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
    ref={ref}
  >
    <g clipPath='url(#clip0_2540_4554)'>
      <path
        d='M12.8646 2.99996L22.3906 19.5C22.4784 19.652 22.5246 19.8244 22.5246 20C22.5246 20.1755 22.4784 20.3479 22.3906 20.4999C22.3029 20.652 22.1766 20.7782 22.0246 20.866C21.8726 20.9537 21.7002 21 21.5246 21H2.47263C2.2971 21 2.12466 20.9537 1.97264 20.866C1.82062 20.7782 1.69439 20.652 1.60662 20.4999C1.51886 20.3479 1.47266 20.1755 1.47266 20C1.47266 19.8244 1.51886 19.652 1.60663 19.5L11.1326 2.99996C11.2204 2.84795 11.3466 2.72172 11.4987 2.63396C11.6507 2.5462 11.8231 2.5 11.9986 2.5C12.1742 2.5 12.3466 2.5462 12.4986 2.63396C12.6506 2.72172 12.7769 2.84795 12.8646 2.99996ZM4.20463 19H19.7926L11.9986 5.49996L4.20463 19ZM10.9986 16H12.9986V18H10.9986V16ZM10.9986 8.99996H12.9986V14H10.9986V8.99996Z'
        // fill='#5D6E82'
        fill='currentColor'
      />
    </g>
    <defs>
      <clipPath id='clip0_2540_4554'>
        <rect width='24' height='24' fill='white' />
      </clipPath>
    </defs>
  </svg>
);
export const TimerFlashIcon = ({
  ref,
  ...props
}: React.SVGProps<SVGSVGElement> & {
  ref?: React.RefObject<SVGSVGElement>;
}) => (
  <svg
    width='18'
    height='18'
    viewBox='0 0 18 18'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
    ref={ref}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M4.75676 4.75736C3.99244 5.52167 3.45563 6.47096 3.18991 7.5H1.64941C2.34429 4.07657 5.37085 1.5 8.9994 1.5C13.1416 1.5 16.4994 4.85775 16.4994 9C16.4994 12.6285 13.9228 15.6551 10.4994 16.35V14.8095C11.5284 14.5438 12.4777 14.007 13.242 13.2426C14.3673 12.1174 14.9994 10.5913 14.9994 9C14.9994 7.4087 14.3673 5.88258 13.242 4.75736C12.1168 3.63214 10.5907 3 8.9994 3C7.4081 3 5.88198 3.63214 4.75676 4.75736ZM8.2494 10.5H12.7494V9H9.7494V5.25H8.2494L8.2494 7.5L8.2494 10.5Z'
      fill='currentColor'
    />
    <rect x='3.75' y='15' width='5.25' height='1.5' fill='currentColor' />
    <rect y='12' width='7.5' height='1.5' fill='currentColor' />
    <rect x='1.5' y='9' width='4.5' height='1.5' fill='currentColor' />
  </svg>
);
export const ShoppingCartIcon = ({
  ref,
  ...props
}: React.SVGProps<SVGSVGElement> & {
  ref?: React.RefObject<SVGSVGElement>;
}) => (
  <svg
    width='1em'
    height='1em'
    viewBox='0 0 24 25'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
    ref={ref}
  >
    <g clipPath='url(#clip0_2540_24862)'>
      <path
        d='M4 16.5V4.5H2V2.5H5C5.26522 2.5 5.51957 2.60536 5.70711 2.79289C5.89464 2.98043 6 3.23478 6 3.5V15.5H18.438L20.438 7.5H8V5.5H21.72C21.872 5.5 22.022 5.53466 22.1586 5.60134C22.2952 5.66801 22.4148 5.76495 22.5083 5.88479C22.6019 6.00462 22.6668 6.1442 22.6983 6.29291C22.7298 6.44162 22.7269 6.59555 22.69 6.743L20.19 16.743C20.1358 16.9592 20.011 17.1512 19.8352 17.2883C19.6595 17.4255 19.4429 17.5 19.22 17.5H5C4.73478 17.5 4.48043 17.3946 4.29289 17.2071C4.10536 17.0196 4 16.7652 4 16.5ZM6 23.5C5.46957 23.5 4.96086 23.2893 4.58579 22.9142C4.21071 22.5391 4 22.0304 4 21.5C4 20.9696 4.21071 20.4609 4.58579 20.0858C4.96086 19.7107 5.46957 19.5 6 19.5C6.53043 19.5 7.03914 19.7107 7.41421 20.0858C7.78929 20.4609 8 20.9696 8 21.5C8 22.0304 7.78929 22.5391 7.41421 22.9142C7.03914 23.2893 6.53043 23.5 6 23.5ZM18 23.5C17.4696 23.5 16.9609 23.2893 16.5858 22.9142C16.2107 22.5391 16 22.0304 16 21.5C16 20.9696 16.2107 20.4609 16.5858 20.0858C16.9609 19.7107 17.4696 19.5 18 19.5C18.5304 19.5 19.0391 19.7107 19.4142 20.0858C19.7893 20.4609 20 20.9696 20 21.5C20 22.0304 19.7893 22.5391 19.4142 22.9142C19.0391 23.2893 18.5304 23.5 18 23.5Z'
        fill='currentColor'
      />
    </g>
    <defs>
      <clipPath id='clip0_2540_24862'>
        <rect
          width='24'
          height='24'
          fill='currentColor'
          transform='translate(0 0.5)'
        />
      </clipPath>
    </defs>
  </svg>
);
export const WarehouseIcon = ({
  ref,
  ...props
}: React.SVGProps<SVGSVGElement> & {
  ref?: React.RefObject<SVGSVGElement>;
}) => (
  <svg
    stroke='currentColor'
    fill='currentColor'
    strokeWidth='0'
    viewBox='0 0 640 512'
    height='1em'
    width='1em'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
    ref={ref}
  >
    <path d='M504 352H136.4c-4.4 0-8 3.6-8 8l-.1 48c0 4.4 3.6 8 8 8H504c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm0 96H136.1c-4.4 0-8 3.6-8 8l-.1 48c0 4.4 3.6 8 8 8h368c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm0-192H136.6c-4.4 0-8 3.6-8 8l-.1 48c0 4.4 3.6 8 8 8H504c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm106.5-139L338.4 3.7a48.15 48.15 0 0 0-36.9 0L29.5 117C11.7 124.5 0 141.9 0 161.3V504c0 4.4 3.6 8 8 8h80c4.4 0 8-3.6 8-8V256c0-17.6 14.6-32 32.6-32h382.8c18 0 32.6 14.4 32.6 32v248c0 4.4 3.6 8 8 8h80c4.4 0 8-3.6 8-8V161.3c0-19.4-11.7-36.8-29.5-44.3z'></path>
  </svg>
);
export const UsersIcon = ({
  ref,
  ...props
}: React.SVGProps<SVGSVGElement> & {
  ref?: React.RefObject<SVGSVGElement>;
}) => (
  <svg
    stroke='currentColor'
    fill='currentColor'
    strokeWidth='0'
    viewBox='0 0 640 512'
    height='1em'
    width='1em'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
    ref={ref}
  >
    <path d='M96 224c35.3 0 64-28.7 64-64s-28.7-64-64-64-64 28.7-64 64 28.7 64 64 64zm448 0c35.3 0 64-28.7 64-64s-28.7-64-64-64-64 28.7-64 64 28.7 64 64 64zm32 32h-64c-17.6 0-33.5 7.1-45.1 18.6 40.3 22.1 68.9 62 75.1 109.4h66c17.7 0 32-14.3 32-32v-32c0-35.3-28.7-64-64-64zm-256 0c61.9 0 112-50.1 112-112S381.9 32 320 32 208 82.1 208 144s50.1 112 112 112zm76.8 32h-8.3c-20.8 10-43.9 16-68.5 16s-47.6-6-68.5-16h-8.3C179.6 288 128 339.6 128 403.2V432c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48v-28.8c0-63.6-51.6-115.2-115.2-115.2zm-223.7-13.4C161.5 263.1 145.6 256 128 256H64c-35.3 0-64 28.7-64 64v32c0 17.7 14.3 32 32 32h65.9c6.3-47.4 34.9-87.3 75.2-109.4z'></path>
  </svg>
);
export const BuildingIcon = ({
  ref,
  ...props
}: React.SVGProps<SVGSVGElement> & {
  ref?: React.RefObject<SVGSVGElement>;
}) => (
  <svg
    stroke='currentColor'
    fill='currentColor'
    strokeWidth='0'
    viewBox='0 0 448 512'
    height='1em'
    width='1em'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
    ref={ref}
  >
    <path d='M436 480h-20V24c0-13.255-10.745-24-24-24H56C42.745 0 32 10.745 32 24v456H12c-6.627 0-12 5.373-12 12v20h448v-20c0-6.627-5.373-12-12-12zM128 76c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40c0 6.627-5.373 12-12 12h-40c-6.627 0-12-5.373-12-12V76zm0 96c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40c0 6.627-5.373 12-12 12h-40c-6.627 0-12-5.373-12-12v-40zm52 148h-40c-6.627 0-12-5.373-12-12v-40c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40c0 6.627-5.373 12-12 12zm76 160h-64v-84c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v84zm64-172c0 6.627-5.373 12-12 12h-40c-6.627 0-12-5.373-12-12v-40c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40zm0-96c0 6.627-5.373 12-12 12h-40c-6.627 0-12-5.373-12-12v-40c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40zm0-96c0 6.627-5.373 12-12 12h-40c-6.627 0-12-5.373-12-12V76c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40z'></path>
  </svg>
);
export const CogsIcon = ({
  ref,
  ...props
}: React.SVGProps<SVGSVGElement> & {
  ref?: React.RefObject<SVGSVGElement>;
}) => (
  <svg
    stroke='currentColor'
    fill='currentColor'
    strokeWidth='0'
    viewBox='0 0 640 512'
    height='1em'
    width='1em'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
    ref={ref}
  >
    <path d='M512.1 191l-8.2 14.3c-3 5.3-9.4 7.5-15.1 5.4-11.8-4.4-22.6-10.7-32.1-18.6-4.6-3.8-5.8-10.5-2.8-15.7l8.2-14.3c-6.9-8-12.3-17.3-15.9-27.4h-16.5c-6 0-11.2-4.3-12.2-10.3-2-12-2.1-24.6 0-37.1 1-6 6.2-10.4 12.2-10.4h16.5c3.6-10.1 9-19.4 15.9-27.4l-8.2-14.3c-3-5.2-1.9-11.9 2.8-15.7 9.5-7.9 20.4-14.2 32.1-18.6 5.7-2.1 12.1.1 15.1 5.4l8.2 14.3c10.5-1.9 21.2-1.9 31.7 0L552 6.3c3-5.3 9.4-7.5 15.1-5.4 11.8 4.4 22.6 10.7 32.1 18.6 4.6 3.8 5.8 10.5 2.8 15.7l-8.2 14.3c6.9 8 12.3 17.3 15.9 27.4h16.5c6 0 11.2 4.3 12.2 10.3 2 12 2.1 24.6 0 37.1-1 6-6.2 10.4-12.2 10.4h-16.5c-3.6 10.1-9 19.4-15.9 27.4l8.2 14.3c3 5.2 1.9 11.9-2.8 15.7-9.5 7.9-20.4 14.2-32.1 18.6-5.7 2.1-12.1-.1-15.1-5.4l-8.2-14.3c-10.4 1.9-21.2 1.9-31.7 0zm-10.5-58.8c38.5 29.6 82.4-14.3 52.8-52.8-38.5-29.7-82.4 14.3-52.8 52.8zM386.3 286.1l33.7 16.8c10.1 5.8 14.5 18.1 10.5 29.1-8.9 24.2-26.4 46.4-42.6 65.8-7.4 8.9-20.2 11.1-30.3 5.3l-29.1-16.8c-16 13.7-34.6 24.6-54.9 31.7v33.6c0 11.6-8.3 21.6-19.7 23.6-24.6 4.2-50.4 4.4-75.9 0-11.5-2-20-11.9-20-23.6V418c-20.3-7.2-38.9-18-54.9-31.7L74 403c-10 5.8-22.9 3.6-30.3-5.3-16.2-19.4-33.3-41.6-42.2-65.7-4-10.9.4-23.2 10.5-29.1l33.3-16.8c-3.9-20.9-3.9-42.4 0-63.4L12 205.8c-10.1-5.8-14.6-18.1-10.5-29 8.9-24.2 26-46.4 42.2-65.8 7.4-8.9 20.2-11.1 30.3-5.3l29.1 16.8c16-13.7 34.6-24.6 54.9-31.7V57.1c0-11.5 8.2-21.5 19.6-23.5 24.6-4.2 50.5-4.4 76-.1 11.5 2 20 11.9 20 23.6v33.6c20.3 7.2 38.9 18 54.9 31.7l29.1-16.8c10-5.8 22.9-3.6 30.3 5.3 16.2 19.4 33.2 41.6 42.1 65.8 4 10.9.1 23.2-10 29.1l-33.7 16.8c3.9 21 3.9 42.5 0 63.5zm-117.6 21.1c59.2-77-28.7-164.9-105.7-105.7-59.2 77 28.7 164.9 105.7 105.7zm243.4 182.7l-8.2 14.3c-3 5.3-9.4 7.5-15.1 5.4-11.8-4.4-22.6-10.7-32.1-18.6-4.6-3.8-5.8-10.5-2.8-15.7l8.2-14.3c-6.9-8-12.3-17.3-15.9-27.4h-16.5c-6 0-11.2-4.3-12.2-10.3-2-12-2.1-24.6 0-37.1 1-6 6.2-10.4 12.2-10.4h16.5c3.6-10.1 9-19.4 15.9-27.4l-8.2-14.3c-3-5.2-1.9-11.9 2.8-15.7 9.5-7.9 20.4-14.2 32.1-18.6 5.7-2.1 12.1.1 15.1 5.4l8.2 14.3c10.5-1.9 21.2-1.9 31.7 0l8.2-14.3c3-5.3 9.4-7.5 15.1-5.4 11.8 4.4 22.6 10.7 32.1 18.6 4.6 3.8 5.8 10.5 2.8 15.7l-8.2 14.3c6.9 8 12.3 17.3 15.9 27.4h16.5c6 0 11.2 4.3 12.2 10.3 2 12 2.1 24.6 0 37.1-1 6-6.2 10.4-12.2 10.4h-16.5c-3.6 10.1-9 19.4-15.9 27.4l8.2 14.3c3 5.2 1.9 11.9-2.8 15.7-9.5 7.9-20.4 14.2-32.1 18.6-5.7 2.1-12.1-.1-15.1-5.4l-8.2-14.3c-10.4 1.9-21.2 1.9-31.7 0zM501.6 431c38.5 29.6 82.4-14.3 52.8-52.8-38.5-29.6-82.4 14.3-52.8 52.8z'></path>
  </svg>
);
export const HistoryIcon = ({
  ref,
  ...props
}: React.SVGProps<SVGSVGElement> & {
  ref?: React.RefObject<SVGSVGElement>;
}) => (
  <svg
    stroke='currentColor'
    fill='currentColor'
    strokeWidth='0'
    viewBox='0 0 512 512'
    height='1em'
    width='1em'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
    ref={ref}
  >
    <path d='M504 255.531c.253 136.64-111.18 248.372-247.82 248.468-59.015.042-113.223-20.53-155.822-54.911-11.077-8.94-11.905-25.541-1.839-35.607l11.267-11.267c8.609-8.609 22.353-9.551 31.891-1.984C173.062 425.135 212.781 440 256 440c101.705 0 184-82.311 184-184 0-101.705-82.311-184-184-184-48.814 0-93.149 18.969-126.068 49.932l50.754 50.754c10.08 10.08 2.941 27.314-11.313 27.314H24c-8.837 0-16-7.163-16-16V38.627c0-14.254 17.234-21.393 27.314-11.314l49.372 49.372C129.209 34.136 189.552 8 256 8c136.81 0 247.747 110.78 248 247.531zm-180.912 78.784l9.823-12.63c8.138-10.463 6.253-25.542-4.21-33.679L288 256.349V152c0-13.255-10.745-24-24-24h-16c-13.255 0-24 10.745-24 24v135.651l65.409 50.874c10.463 8.137 25.541 6.253 33.679-4.21z'></path>
  </svg>
);
export const CollapseIcon = ({
  ref,
  ...props
}: React.SVGProps<SVGSVGElement> & {
  ref?: React.RefObject<SVGSVGElement>;
}) => (
  <svg
    stroke='currentColor'
    fill='currentColor'
    strokeWidth='0'
    viewBox='0 0 24 24'
    height='1em'
    width='1em'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
    ref={ref}
  >
    <path d='M16.121 6.465 14 4.344V10h5.656l-2.121-2.121 3.172-3.172-1.414-1.414zM4.707 3.293 3.293 4.707l3.172 3.172L4.344 10H10V4.344L7.879 6.465zM19.656 14H14v5.656l2.121-2.121 3.172 3.172 1.414-1.414-3.172-3.172zM6.465 16.121l-3.172 3.172 1.414 1.414 3.172-3.172L10 19.656V14H4.344z'></path>
  </svg>
);

export const DownloadIcon = ({
  ref,
  ...props
}: React.SVGProps<SVGSVGElement> & {
  ref?: React.RefObject<SVGSVGElement>;
}) => (
  <svg
    stroke='currentColor'
    fill='currentColor'
    strokeWidth='0'
    viewBox='0 0 512 512'
    height='1em'
    width='1em'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
    ref={ref}
  >
    <path d='M216 0h80c13.3 0 24 10.7 24 24v168h87.7c17.8 0 26.7 21.5 14.1 34.1L269.7 378.3c-7.5 7.5-19.8 7.5-27.3 0L90.1 226.1c-12.6-12.6-3.7-34.1 14.1-34.1H192V24c0-13.3 10.7-24 24-24zm296 376v112c0 13.3-10.7 24-24 24H24c-13.3 0-24-10.7-24-24V376c0-13.3 10.7-24 24-24h146.7l49 49c20.1 20.1 52.5 20.1 72.6 0l49-49H488c13.3 0 24 10.7 24 24zm-124 88c0-11-9-20-20-20s-20 9-20 20 9 20 20 20 20-9 20-20zm64 0c0-11-9-20-20-20s-20 9-20 20 9 20 20 20 20-9 20-20z'></path>
  </svg>
);
export const MapMarkerIcon = ({
  ref,
  ...props
}: React.SVGProps<SVGSVGElement> & {
  ref?: React.RefObject<SVGSVGElement>;
}) => (
  <svg
    stroke='currentColor'
    fill='currentColor'
    strokeWidth='0'
    viewBox='0 0 384 512'
    height='1em'
    width='1em'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
    ref={ref}
  >
    <path d='M172.268 501.67C26.97 291.031 0 269.413 0 192 0 85.961 85.961 0 192 0s192 85.961 192 192c0 77.413-26.97 99.031-172.268 309.67-9.535 13.774-29.93 13.773-39.464 0zM192 272c44.183 0 80-35.817 80-80s-35.817-80-80-80-80 35.817-80 80 35.817 80 80 80z'></path>
  </svg>
);

export const LightBulbIcon = ({
  ref,
  ...props
}: React.SVGProps<SVGSVGElement> & {
  ref?: React.RefObject<SVGSVGElement>;
}) => (
  <svg
    width='18'
    height='18'
    viewBox='0 0 18 18'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
    ref={ref}
  >
    <g clipPath='url(#clip0_2540_28300)'>
      <path
        d='M7.4799 13.5002H10.5204C10.6194 12.5987 11.0792 11.8547 11.8254 11.0425C11.9102 10.951 12.4494 10.3922 12.5132 10.3127C13.0429 9.65095 13.3749 8.85301 13.471 8.01081C13.5671 7.1686 13.4234 6.31638 13.0563 5.55228C12.6893 4.78818 12.114 4.14329 11.3965 3.69186C10.679 3.24043 9.84863 3.00083 9.00096 3.00065C8.15329 3.00047 7.32281 3.23971 6.60515 3.69083C5.88749 4.14196 5.31184 4.78661 4.9445 5.55055C4.57716 6.31449 4.43306 7.16665 4.5288 8.0089C4.62454 8.85114 4.95622 9.64922 5.48565 10.3112C5.55015 10.3915 6.0909 10.951 6.17415 11.0417C6.92115 11.8547 7.3809 12.5987 7.4799 13.5002ZM10.5002 15.0002H7.50015V15.7502H10.5002V15.0002ZM4.31565 11.2502C3.6093 10.3677 3.16661 9.30358 3.0386 8.18045C2.91059 7.05732 3.10245 5.92088 3.59209 4.90203C4.08173 3.88318 4.84923 3.02338 5.80617 2.42166C6.76311 1.81995 7.87057 1.5008 9.00096 1.50098C10.1314 1.50116 11.2387 1.82066 12.1955 2.42269C13.1522 3.02471 13.9194 3.88476 14.4087 4.90377C14.8981 5.92277 15.0896 7.05928 14.9612 8.18236C14.8328 9.30544 14.3898 10.3694 13.6832 11.2517C13.2182 11.8307 12.0002 12.7502 12.0002 13.8752V15.7502C12.0002 16.148 11.8421 16.5296 11.5608 16.8109C11.2795 17.0922 10.898 17.2502 10.5002 17.2502H7.50015C7.10233 17.2502 6.7208 17.0922 6.43949 16.8109C6.15819 16.5296 6.00015 16.148 6.00015 15.7502V13.8752C6.00015 12.7502 4.7814 11.8307 4.31565 11.2502ZM9.75015 7.50322H11.6252L8.25015 12.0032V9.00322H6.37515L9.75015 4.50022V7.50397V7.50322Z'
        fill='currentColor'
      />
    </g>
    <defs>
      <clipPath id='clip0_2540_28300'>
        <rect width='18' height='18' fill='white' />
      </clipPath>
    </defs>
  </svg>
);

export const PlugLineIcon = ({
  ref,
  ...props
}: React.SVGProps<SVGSVGElement> & {
  ref?: React.RefObject<SVGSVGElement>;
}) => (
  <svg
    width='24'
    height='24'
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
    ref={ref}
  >
    <g clipPath='url(#clip0_3028_13845)'>
      <path
        d='M13 18V20H19V22H13C12.4696 22 11.9609 21.7893 11.5858 21.4142C11.2107 21.0391 11 20.5304 11 20V18H8C6.93913 18 5.92172 17.5786 5.17157 16.8284C4.42143 16.0783 4 15.0609 4 14V7C4 6.73478 4.10536 6.48043 4.29289 6.29289C4.48043 6.10536 4.73478 6 5 6H8V2H10V6H14V2H16V6H19C19.2652 6 19.5196 6.10536 19.7071 6.29289C19.8946 6.48043 20 6.73478 20 7V14C20 15.0609 19.5786 16.0783 18.8284 16.8284C18.0783 17.5786 17.0609 18 16 18H13ZM8 16H16C16.5304 16 17.0391 15.7893 17.4142 15.4142C17.7893 15.0391 18 14.5304 18 14V11H6V14C6 14.5304 6.21071 15.0391 6.58579 15.4142C6.96086 15.7893 7.46957 16 8 16ZM18 8H6V9H18V8ZM12 14.5C11.7348 14.5 11.4804 14.3946 11.2929 14.2071C11.1054 14.0196 11 13.7652 11 13.5C11 13.2348 11.1054 12.9804 11.2929 12.7929C11.4804 12.6054 11.7348 12.5 12 12.5C12.2652 12.5 12.5196 12.6054 12.7071 12.7929C12.8946 12.9804 13 13.2348 13 13.5C13 13.7652 12.8946 14.0196 12.7071 14.2071C12.5196 14.3946 12.2652 14.5 12 14.5Z'
        fill='currentColor'
      />
    </g>
    <defs>
      <clipPath id='clip0_3028_13845'>
        <rect width='24' height='24' fill='white' />
      </clipPath>
    </defs>
  </svg>
);
export const LeafLineIcon = ({
  ref,
  ...props
}: React.SVGProps<SVGSVGElement> & {
  ref?: React.RefObject<SVGSVGElement>;
}) => (
  <svg
    width='24'
    height='24'
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
    ref={ref}
  >
    <g clipPath='url(#clip0_3028_13849)'>
      <path
        d='M21 3V5C21 14.627 15.627 19 9 19H5.243C5.08 19.912 5 20.907 5 22H3C3 20.637 3.116 19.4 3.346 18.268C3.116 16.974 3 15.218 3 13C3 7.477 7.477 3 13 3C15 3 17 4 21 3ZM13 5C8.582 5 5 8.582 5 13C5 13.362 5.003 13.711 5.01 14.046C6.264 12.068 8.101 10.505 10.504 9.132L11.496 10.868C8.641 12.5 6.747 14.354 5.776 17H9C15.015 17 18.871 13.027 18.997 5.388C17.625 5.521 16.35 5.436 14.777 5.2C13.627 5.027 13.401 5 13 5Z'
        fill='currentColor'
      />
    </g>
    <defs>
      <clipPath id='clip0_3028_13849'>
        <rect width='24' height='24' fill='white' />
      </clipPath>
    </defs>
  </svg>
);
export const DashboardIcon = ({
  ref,
  ...props
}: React.SVGProps<SVGSVGElement> & {
  ref?: React.RefObject<SVGSVGElement>;
}) => (
  <svg
    width='24'
    height='24'
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
    ref={ref}
  >
    <g clipPath='url(#clip0_3534_20673)'>
      <path
        d='M12 2C17.523 2 22 6.477 22 12C22 17.523 17.523 22 12 22C6.477 22 2 17.523 2 12C2 6.477 6.477 2 12 2ZM12 4C7.582 4 4 7.582 4 12C4 16.418 7.582 20 12 20C16.418 20 20 16.418 20 12C20 7.582 16.418 4 12 4ZM15.833 7.337C16.07 7.171 16.392 7.199 16.596 7.404C16.8 7.608 16.826 7.93 16.659 8.164C14.479 11.21 13.279 12.842 13.061 13.061C12.475 13.646 11.525 13.646 10.939 13.061C10.354 12.475 10.354 11.525 10.939 10.939C11.313 10.566 12.944 9.365 15.833 7.337ZM17.5 11C18.052 11 18.5 11.448 18.5 12C18.5 12.552 18.052 13 17.5 13C16.948 13 16.5 12.552 16.5 12C16.5 11.448 16.948 11 17.5 11ZM6.5 11C7.052 11 7.5 11.448 7.5 12C7.5 12.552 7.052 13 6.5 13C5.948 13 5.5 12.552 5.5 12C5.5 11.448 5.948 11 6.5 11ZM8.818 7.404C9.208 7.794 9.208 8.427 8.818 8.818C8.428 9.208 7.794 9.208 7.404 8.818C7.014 8.428 7.014 7.794 7.404 7.404C7.794 7.014 8.427 7.014 8.818 7.404ZM12 5.5C12.552 5.5 13 5.948 13 6.5C13 7.052 12.552 7.5 12 7.5C11.448 7.5 11 7.052 11 6.5C11 5.948 11.448 5.5 12 5.5Z'
        fill='currentColor'
      />
    </g>
    <defs>
      <clipPath id='clip0_3534_20673'>
        <rect width='24' height='24' fill='white' />
      </clipPath>
    </defs>
  </svg>
);
export const GlobeIcon = ({
  ref,
  ...props
}: React.SVGProps<SVGSVGElement> & {
  ref?: React.RefObject<SVGSVGElement>;
}) => (
  <svg
    width='24'
    height='24'
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
    ref={ref}
  >
    <g clipPath='url(#clip0_2124_84761)'>
      <path
        d='M6.235 6.453C4.96004 7.77629 4.1795 9.49815 4.02457 11.3292C3.86964 13.1602 4.34977 14.9887 5.38426 16.5074C6.41874 18.0261 7.94451 19.1424 9.70511 19.6686C11.4657 20.1948 13.3538 20.0989 15.052 19.397C15.167 18.647 14.915 17.927 14.812 17.675C14.582 17.115 13.824 16.158 12.559 14.831C12.221 14.476 12.243 14.203 12.364 13.394L12.377 13.303C12.459 12.749 12.597 12.421 14.462 12.125C15.41 11.975 15.659 12.353 16.004 12.878L16.12 13.05C16.448 13.53 16.691 13.64 17.058 13.806C17.223 13.881 17.428 13.976 17.703 14.131C18.355 14.504 18.355 14.925 18.355 15.847V15.952C18.355 16.343 18.317 16.687 18.257 16.986C19.0244 16.0229 19.5591 14.8957 19.8196 13.6922C20.0801 12.4886 20.0593 11.2412 19.7588 10.047C19.4584 8.85284 18.8863 7.7441 18.0873 6.80714C17.2883 5.87017 16.2838 5.13026 15.152 4.645C14.599 5.018 13.84 5.547 13.575 5.91C13.44 6.095 13.248 7.042 12.625 7.12C12.463 7.14 12.244 7.126 12.012 7.111C11.39 7.071 10.54 7.016 10.268 7.755C10.095 8.223 10.065 9.495 10.624 10.155C10.714 10.26 10.731 10.455 10.67 10.674C10.59 10.961 10.429 11.136 10.378 11.172C10.282 11.116 10.09 10.893 9.959 10.742C9.646 10.377 9.254 9.922 8.748 9.782C8.564 9.731 8.362 9.689 8.165 9.647C7.616 9.532 6.995 9.401 6.85 9.093C6.744 8.867 6.745 8.556 6.745 8.228C6.745 7.811 6.745 7.34 6.541 6.883C6.47008 6.71991 6.36585 6.57344 6.235 6.453V6.453ZM12 22C6.477 22 2 17.523 2 12C2 6.477 6.477 2 12 2C17.523 2 22 6.477 22 12C22 17.523 17.523 22 12 22Z'
        fill='currentColor'
      />
    </g>
    <defs>
      <clipPath id='clip0_2124_84761'>
        <rect width='24' height='24' fill='white' />
      </clipPath>
    </defs>
  </svg>
);
export const SpinnerIcon = ({
  ref,
  ...props
}: React.SVGProps<SVGSVGElement> & {
  ref?: React.RefObject<SVGSVGElement>;
}) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    fill='none'
    viewBox='0 0 24 24'
    {...props}
    className={`animate-spin ${props.className || ''}`}
    ref={ref}
  >
    <circle
      className='opacity-25'
      cx='12'
      cy='12'
      r='10'
      stroke='currentColor'
      strokeWidth='4'
    ></circle>
    <path
      className='opacity-75'
      fill='currentColor'
      d='M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z'
    ></path>
  </svg>
);
export const CloseCircleIcon = ({
  ref,
  ...props
}: React.SVGProps<SVGSVGElement> & {
  ref?: React.RefObject<SVGSVGElement>;
}) => (
  <svg
    width='21'
    height='21'
    viewBox='0 0 21 21'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
    ref={ref}
  >
    <g clipPath='url(#clip0_3606_19690)'>
      <path
        d='M10.5003 18.3333C5.89783 18.3333 2.16699 14.6025 2.16699 10C2.16699 5.3975 5.89783 1.66667 10.5003 1.66667C15.1028 1.66667 18.8337 5.3975 18.8337 10C18.8337 14.6025 15.1028 18.3333 10.5003 18.3333ZM10.5003 16.6667C12.2684 16.6667 13.9641 15.9643 15.2144 14.714C16.4646 13.4638 17.167 11.7681 17.167 10C17.167 8.23189 16.4646 6.5362 15.2144 5.28596C13.9641 4.03571 12.2684 3.33333 10.5003 3.33333C8.73222 3.33333 7.03652 4.03571 5.78628 5.28596C4.53604 6.5362 3.83366 8.23189 3.83366 10C3.83366 11.7681 4.53604 13.4638 5.78628 14.714C7.03652 15.9643 8.73222 16.6667 10.5003 16.6667V16.6667ZM10.5003 8.82167L12.857 6.46417L14.0362 7.64333L11.6787 10L14.0362 12.3567L12.857 13.5358L10.5003 11.1783L8.14366 13.5358L6.96449 12.3567L9.32199 10L6.96449 7.64333L8.14366 6.46417L10.5003 8.82167Z'
        fill='currentColor'
      />
    </g>
    <defs>
      <clipPath id='clip0_3606_19690'>
        <rect width='20' height='20' fill='white' transform='translate(0.5)' />
      </clipPath>
    </defs>
  </svg>
);

export const ArrowLeftSLineIcon = ({
  ref,
  ...props
}: React.SVGProps<SVGSVGElement> & {
  ref?: React.RefObject<SVGSVGElement>;
}) => (
  <svg
    width='24'
    height='24'
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
    ref={ref}
  >
    <g clipPath='url(#clip0_3716_658)'>
      <path
        d='M8.67864 11.6323L13.8129 6.2715C14.0775 6.02408 14.4745 6.02408 14.7127 6.2715L15.3214 6.90381C15.5595 7.15123 15.5595 7.5636 15.3214 7.83851L11.2457 12.0722L15.3214 16.3334C15.5595 16.6083 15.5595 17.0206 15.3214 17.2681L14.7127 17.9004C14.4745 18.1478 14.0775 18.1478 13.8129 17.9004L8.67864 12.5395C8.44045 12.2921 8.44045 11.8798 8.67864 11.6323Z'
        fill='#5D6E82'
      />
    </g>
    <defs>
      <clipPath id='clip0_3716_658'>
        <rect width='24' height='24' fill='white' />
      </clipPath>
    </defs>
  </svg>
);

export const DeleteBinLineIcon = ({
  ref,
  ...props
}: React.SVGProps<SVGSVGElement> & {
  ref?: React.RefObject<SVGSVGElement>;
}) => (
  <svg
    width='20'
    height='20'
    viewBox='0 0 20 20'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
    ref={ref}
  >
    <g clipPath='url(#clip0_3716_17719)'>
      <path
        d='M14.1667 4.99984H18.3334V6.6665H16.6667V17.4998C16.6667 17.7209 16.579 17.9328 16.4227 18.0891C16.2664 18.2454 16.0544 18.3332 15.8334 18.3332H4.16675C3.94573 18.3332 3.73377 18.2454 3.57749 18.0891C3.42121 17.9328 3.33341 17.7209 3.33341 17.4998V6.6665H1.66675V4.99984H5.83342V2.49984C5.83342 2.27882 5.92121 2.06686 6.07749 1.91058C6.23377 1.7543 6.44573 1.6665 6.66675 1.6665H13.3334C13.5544 1.6665 13.7664 1.7543 13.9227 1.91058C14.079 2.06686 14.1667 2.27882 14.1667 2.49984V4.99984ZM15.0001 6.6665H5.00008V16.6665H15.0001V6.6665ZM7.50008 9.1665H9.16675V14.1665H7.50008V9.1665ZM10.8334 9.1665H12.5001V14.1665H10.8334V9.1665ZM7.50008 3.33317V4.99984H12.5001V3.33317H7.50008Z'
        fill='#5D6E82'
      />
    </g>
    <defs>
      <clipPath id='clip0_3716_17719'>
        <rect width='20' height='20' fill='white' />
      </clipPath>
    </defs>
  </svg>
);

export const FootballFillIcon = ({
  ref,
  ...props
}: React.SVGProps<SVGSVGElement> & {
  ref?: React.RefObject<SVGSVGElement>;
}) => (
  <svg
    width='18'
    height='19'
    viewBox='0 0 18 19'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
    ref={ref}
  >
    <g clipPath='url(#clip0_3738_5626)'>
      <path
        d='M9 2C13.1423 2 16.5 5.35775 16.5 9.5C16.5 13.6423 13.1423 17 9 17C4.85775 17 1.5 13.6423 1.5 9.5C1.5 5.35775 4.85775 2 9 2ZM10.2525 12.5H7.7475L6.7125 13.9227L7.128 15.2023C7.73226 15.4002 8.36416 15.5007 9 15.5C9.65325 15.5 10.2825 15.395 10.872 15.2023L11.2867 13.9227L10.2517 12.5H10.2525ZM3.9705 8.654L3.0015 9.35675L3 9.5C3 10.7975 3.41175 11.9982 4.1115 12.98H5.544L6.53625 11.615L5.76525 9.2375L3.9705 8.654ZM14.0295 8.654L12.2347 9.2375L11.4637 11.615L12.4552 12.98H13.8878C14.6129 11.9646 15.0018 10.7477 15 9.5L14.9977 9.35675L14.0295 8.654ZM10.7175 3.74975L9.75 4.45475V6.3425L11.7705 7.81025L13.4498 7.265L13.8652 5.98775C13.091 4.9159 11.9849 4.12929 10.7183 3.74975H10.7175ZM7.281 3.74975C6.01428 4.12948 4.90816 4.91637 4.134 5.9885L4.5495 7.265L6.22875 7.81025L8.25 6.3425V4.45475L7.28175 3.74975H7.281Z'
        fill='currentColor'
      />
    </g>
    <defs>
      <clipPath id='clip0_3738_5626'>
        <rect
          width='18'
          height='18'
          fill='white'
          transform='translate(0 0.5)'
        />
      </clipPath>
    </defs>
  </svg>
);

export const TimeSpeedIcon = ({
  ref,
  ...props
}: React.SVGProps<SVGSVGElement> & {
  ref?: React.RefObject<SVGSVGElement>;
}) => (
  <svg
    width='18'
    height='19'
    viewBox='0 0 18 19'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
    ref={ref}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M4.75676 5.25736C3.99244 6.02167 3.45563 6.97096 3.18991 8H1.64941C2.34429 4.57657 5.37085 2 8.9994 2C13.1416 2 16.4994 5.35775 16.4994 9.5C16.4994 13.1285 13.9228 16.1551 10.4994 16.85V15.3095C11.5284 15.0438 12.4777 14.507 13.242 13.7426C14.3673 12.6174 14.9994 11.0913 14.9994 9.5C14.9994 7.9087 14.3673 6.38258 13.242 5.25736C12.1168 4.13214 10.5907 3.5 8.9994 3.5C7.4081 3.5 5.88198 4.13214 4.75676 5.25736ZM8.2494 11H12.7494V9.5H9.7494V5.75H8.2494L8.2494 8L8.2494 11Z'
      fill='currentColor'
    />
    <rect x='3.75' y='15.5' width='5.25' height='1.5' fill='currentColor' />
    <rect y='12.5' width='7.5' height='1.5' fill='currentColor' />
    <rect x='1.5' y='9.5' width='4.5' height='1.5' fill='currentColor' />
  </svg>
);

export const ErrorWarningLineIcon = ({
  ref,
  ...props
}: React.SVGProps<SVGSVGElement> & {
  ref?: React.RefObject<SVGSVGElement>;
}) => (
  <svg
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
    ref={ref}
  >
    <g clipPath='url(#clip0_3852_3275)'>
      <path
        d='M8.00016 14.6668C4.31816 14.6668 1.3335 11.6822 1.3335 8.00016C1.3335 4.31816 4.31816 1.3335 8.00016 1.3335C11.6822 1.3335 14.6668 4.31816 14.6668 8.00016C14.6668 11.6822 11.6822 14.6668 8.00016 14.6668ZM8.00016 13.3335C9.41465 13.3335 10.7712 12.7716 11.7714 11.7714C12.7716 10.7712 13.3335 9.41465 13.3335 8.00016C13.3335 6.58567 12.7716 5.22912 11.7714 4.22893C10.7712 3.22873 9.41465 2.66683 8.00016 2.66683C6.58567 2.66683 5.22912 3.22873 4.22893 4.22893C3.22873 5.22912 2.66683 6.58567 2.66683 8.00016C2.66683 9.41465 3.22873 10.7712 4.22893 11.7714C5.22912 12.7716 6.58567 13.3335 8.00016 13.3335ZM7.3335 10.0002H8.66683V11.3335H7.3335V10.0002ZM7.3335 4.66683H8.66683V8.66683H7.3335V4.66683Z'
        fill='currentColor'
      />
    </g>
    <defs>
      <clipPath id='clip0_3852_3275'>
        <rect width='16' height='16' fill='white' />
      </clipPath>
    </defs>
  </svg>
);
export const ChatLineIcon = ({
  ref,
  ...props
}: React.SVGProps<SVGSVGElement> & {
  ref?: React.RefObject<SVGSVGElement>;
}) => (
  <svg
    width='24'
    height='24'
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
    ref={ref}
  >
    <g clipPath='url(#clip0_3304_81725)'>
      <path
        d='M10 3H14C16.1217 3 18.1566 3.84285 19.6569 5.34315C21.1571 6.84344 22 8.87827 22 11C22 13.1217 21.1571 15.1566 19.6569 16.6569C18.1566 18.1571 16.1217 19 14 19V22.5C9 20.5 2 17.5 2 11C2 8.87827 2.84285 6.84344 4.34315 5.34315C5.84344 3.84285 7.87827 3 10 3ZM12 17H14C14.7879 17 15.5681 16.8448 16.2961 16.5433C17.0241 16.2417 17.6855 15.7998 18.2426 15.2426C18.7998 14.6855 19.2417 14.0241 19.5433 13.2961C19.8448 12.5681 20 11.7879 20 11C20 10.2121 19.8448 9.43185 19.5433 8.7039C19.2417 7.97595 18.7998 7.31451 18.2426 6.75736C17.6855 6.20021 17.0241 5.75825 16.2961 5.45672C15.5681 5.15519 14.7879 5 14 5H10C8.4087 5 6.88258 5.63214 5.75736 6.75736C4.63214 7.88258 4 9.4087 4 11C4 14.61 6.462 16.966 12 19.48V17Z'
        fill='currentColor'
      />
    </g>
    <defs>
      <clipPath id='clip0_3304_81725'>
        <rect width='24' height='24' fill='white' />
      </clipPath>
    </defs>
  </svg>
);
export const CheckMarkIcon = ({
  ref,
  ...props
}: React.SVGProps<SVGSVGElement> & {
  ref?: React.RefObject<SVGSVGElement>;
}) => (
  <svg
    width='20'
    height='20'
    viewBox='0 0 20 20'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
    ref={ref}
  >
    <g clipPath='url(#clip0_445_12676)'>
      <path
        d='M8.33361 12.6429L15.9936 4.98206L17.1728 6.16039L8.33361 14.9996L3.03027 9.69622L4.20861 8.51789L8.33361 12.6429Z'
        fill='currentColor'
      />
    </g>
    <defs>
      <clipPath id='clip0_445_12676'>
        <rect width='20' height='20' fill='white' />
      </clipPath>
    </defs>
  </svg>
);

export const EyeIcon = ({
  ref,
  ...props
}: React.SVGProps<SVGSVGElement> & {
  ref?: React.RefObject<SVGSVGElement>;
}) => (
  <svg
    width='20'
    height='20'
    viewBox='0 0 20 20'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    ref={ref}
    {...props}
  >
    <g clipPath='url(#clip0_3057_1292)'>
      <path
        d='M9.99874 2.5C14.4921 2.5 18.2304 5.73333 19.0146 10C18.2312 14.2667 14.4921 17.5 9.99874 17.5C5.50541 17.5 1.76708 14.2667 0.98291 10C1.76624 5.73333 5.50541 2.5 9.99874 2.5ZM9.99874 15.8333C11.6983 15.833 13.3474 15.2557 14.6761 14.196C16.0048 13.1363 16.9345 11.6569 17.3129 10C16.9331 8.34442 16.0029 6.86667 14.6743 5.80835C13.3457 4.75004 11.6973 4.17377 9.99874 4.17377C8.30016 4.17377 6.65182 4.75004 5.32322 5.80835C3.99463 6.86667 3.06438 8.34442 2.68458 10C3.06299 11.6569 3.99264 13.1363 5.32136 14.196C6.65009 15.2557 8.29919 15.833 9.99874 15.8333ZM9.99874 13.75C9.00418 13.75 8.05036 13.3549 7.34709 12.6516C6.64383 11.9484 6.24874 10.9946 6.24874 10C6.24874 9.00544 6.64383 8.05161 7.34709 7.34835C8.05036 6.64509 9.00418 6.25 9.99874 6.25C10.9933 6.25 11.9471 6.64509 12.6504 7.34835C13.3537 8.05161 13.7487 9.00544 13.7487 10C13.7487 10.9946 13.3537 11.9484 12.6504 12.6516C11.9471 13.3549 10.9933 13.75 9.99874 13.75ZM9.99874 12.0833C10.5513 12.0833 11.0812 11.8638 11.4719 11.4731C11.8626 11.0824 12.0821 10.5525 12.0821 10C12.0821 9.44747 11.8626 8.91756 11.4719 8.52686C11.0812 8.13616 10.5513 7.91667 9.99874 7.91667C9.44621 7.91667 8.91631 8.13616 8.5256 8.52686C8.1349 8.91756 7.91541 9.44747 7.91541 10C7.91541 10.5525 8.1349 11.0824 8.5256 11.4731C8.91631 11.8638 9.44621 12.0833 9.99874 12.0833Z'
        // fill='#5D6E82'
        fill='currentColor'
      />
    </g>
    <defs>
      <clipPath id='clip0_3057_1292'>
        <rect width='20' height='20' fill='white' />
      </clipPath>
    </defs>
  </svg>
);

export const GroupIcon = ({
  ref,
  ...props
}: React.SVGProps<SVGSVGElement> & {
  ref?: React.RefObject<SVGSVGElement>;
}) => (
  <svg
    width='25'
    height='24'
    viewBox='0 0 25 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
    ref={ref}
  >
    <path
      d='M11.5 11V5H13.5V11H19.5V13H13.5V19H11.5V13H5.5V11H11.5Z'
      fill='currentColor'
    />
  </svg>
);

export const CheckBoxCircleIcon = ({
  ref,
  ...props
}: React.SVGProps<SVGSVGElement> & {
  ref?: React.RefObject<SVGSVGElement>;
}) => (
  <svg
    width='24'
    height='24'
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
    ref={ref}
  >
    <path
      d='M12 22C6.477 22 2 17.523 2 12C2 6.477 6.477 2 12 2C17.523 2 22 6.477 22 12C22 17.523 17.523 22 12 22ZM12 20C14.1217 20 16.1566 19.1571 17.6569 17.6569C19.1571 16.1566 20 14.1217 20 12C20 9.87827 19.1571 7.84344 17.6569 6.34315C16.1566 4.84285 14.1217 4 12 4C9.87827 4 7.84344 4.84285 6.34315 6.34315C4.84285 7.84344 4 9.87827 4 12C4 14.1217 4.84285 16.1566 6.34315 17.6569C7.84344 19.1571 9.87827 20 12 20ZM11.003 16L6.76 11.757L8.174 10.343L11.003 13.172L16.659 7.515L18.074 8.929L11.003 16Z'
      fill='currentColor'
    />
  </svg>
);

export const EnvelopeIcon = ({
  ref,
  ...props
}: React.SVGProps<SVGSVGElement> & {
  ref?: React.RefObject<SVGSVGElement>;
}) => (
  <svg
    fill='none'
    width='24px'
    height='24px'
    viewBox='0 0 1920 1920'
    xmlns='http://www.w3.org/2000/svg'
    ref={ref}
    {...props}
  >
    <g>
      {' '}
      <path
        d='M0 1694.235h1920V226H0v1468.235ZM112.941 376.664V338.94H1807.06v37.723L960 1111.233l-847.059-734.57ZM1807.06 526.198v950.513l-351.134-438.89-88.32 70.475 378.353 472.998H174.042l378.353-472.998-88.32-70.475-351.134 438.89V526.198L960 1260.768l847.059-734.57Z'
        fillRule='evenodd'
        fill='currentColor'
      ></path>
    </g>
  </svg>
);
